class BetterFileInput {
  constructor() {
    this.load()
  }

  load() {
    $(document).on("change", ".custom-file-input:file", function () {
      var input = $(this),
        numFiles = input.get(0).files ? input.get(0).files.length : 1,
        label = input.val().replace(/\\/g, "/").replace(/.*\//, "")
      input.trigger("fileselect", [numFiles, label])
    })

    $(".custom-file-label").text("Choose a file")
    $(".custom-file-input:file").on(
      "fileselect",
      function (event, numFiles, label) {
        var input = $(this).parents(".custom-file").find("label"),
          log = numFiles > 1 ? numFiles + " files selected" : label

        if (input.length) {
          input.html(log)
        } else {
          if (log) alert(log)
        }
      }
    )
  }
}

export { BetterFileInput }
